import type { ReactNode } from "react";
import { useCallback } from "react";
import type { Category } from "..";

interface TabProps {
  tab: Category;
  label: string;
  icon: ReactNode;
  className?: string;
  quantity: number;
  onSelect: (tab: Category) => void;
}

export const Tab = ({ tab, icon, label, quantity, className, onSelect }: TabProps) => {
  const onClickCategory = useCallback(() => {
    onSelect(tab);
  }, [onSelect, tab]);

  return (
    <div
      onClick={onClickCategory}
      className={`flex w-[33%] cursor-pointer flex-row items-center space-x-2 rounded-xl p-2 text-sm transition-colors duration-300 ${className}`}
    >
      {icon}
      <p>
        {quantity} {label}
      </p>
    </div>
  );
};
